import React, { useEffect, useRef, useState } from 'react';
import { MdKeyboardBackspace, MdOutlineDelete } from 'react-icons/md';
import {
    Button,
    Col,
    Form,
    Input,
    Row,
    Space,
    Switch,
    Upload,
    Select,
    Table,
    Modal,
    message,
    Tag,
    Tooltip,
} from 'antd';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Loader from '../../../../../Components/Loader/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { workspaces_Folder_Create_ActionHandler } from '../../../../../Redux/Actions/user/WorkspaceFolderCreate';
import { workspaces_Supporting_Document_FolderCreate_ActionHandler } from '../../../../../Redux/Actions/user/WorkspaceSupportingDocumentFolderCreate';
import { workspaces_Output_Template_FolderCreate_ActionHandler } from '../../../../../Redux/Actions/user/WorkspacesOutputTemplateFolderCreate';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEdiorConfig } from '../../../../../Config/CKEdiorConfig';
import {
    getAllUserList,
    workspace_folder_data,
    workspace_folder_update_api,
} from '../../../../../Redux/Apis/user/ApiConfig';
import { PlusOutlined } from '@ant-design/icons';
import AddAccount from './AddAccount';
import { workspaces_List_ActionHandler } from '../../../../../Redux/Actions/user/WorkspacesList';
import EditAccount from './EditAccount';
import Swal from 'sweetalert2';
import { workspaces_Supporting_Document_FolderCreate_Restrict_ActionHandler } from '../../../../../Redux/Actions/user/WorkspaceSupportingDocumentFolderCreateRestrict';
const { Option } = Select;
const { TextArea } = Input;
const lock = '/assets/black-lock.svg';
const eye_icon = '/assets/Eye_Bulk.svg';
const editIcon = '/assets/edit.svg';
const trash = '/assets/Trash.svg';
const CreateWorkspaceFolder = () => {
    const Workspaces_icon = '/assets/workspace_Icon.svg';
    const editorRef = useRef();
    const [image, setImage] = useState(null);
    const [error, setError] = useState('');
    const [folderName, setFolderName] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [open, setOpen] = useState(false);
    const [editId, setEditId] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [restrict, setRestrict] = useState(true);
    const [data, setData] = useState(null);
    const [mockData, setMockData] = useState([]);
    const [editData, setEditData] = useState();
    const [user, setUser] = useState();
    const [deleteIndex, setDeleteIndex] = useState(null);
    const { id } = useParams();
    const location = useLocation();
    const [answer, setAnswer] = useState('');
    const [selectedClientsForRestricted, setSelectedClientsForRestricted] =
        useState([]);
    const { state } = location;
    let dispatch = useDispatch();
    let Navigate = useNavigate();
    const [form] = Form.useForm();

    const workspaceCreateAction = useSelector(
        (state) => state?.workspaces_folder_create_Data?.loader
    );
    const workspaceCreateActionPublic = useSelector(
        (state) => state?.workspaces_folder_create_Data?.loader
    );
    const workspaceData = useSelector(
        (state) => state?.workspaces_List_Data?.workspace_create_data?.data
    );
    const workspaceCreateSupporting_Document = useSelector(
        (state) =>
            state?.workspaces_Supporting_Document_FolderCreate_Data?.loader
    );
    const workspaceCreate_OutputTemplate = useSelector(
        (state) => state?.workspaces_Output_Teamplate_folder_create_Data?.loader
    );
    const FolderPublicData = useSelector(
        (state) =>
            state?.workspaces_Supporting_Document_FolderCreate_Data
                ?.workspace_supportingDocument_data?.data
    );

    useEffect(() => {
        FolderPublicData?.folder && form.resetFields();
        FolderPublicData?.folder && setMockData(null);
        FolderPublicData?.folder && localStorage.removeItem(`account0`);
        if (FolderPublicData?.folder) {
            let navigateObj = {
                name: state?.name,
                id: state?.id,
            };
            const queryParams = new URLSearchParams(navigateObj).toString();
            const queryParamsObject = Object.fromEntries(
                new URLSearchParams(queryParams)
            );
            Navigate(
                `/workspaces/${queryParamsObject.name}/${queryParamsObject.id}/details`
            );
        }
    }, [FolderPublicData]);
    useEffect(() => {
        dispatch(workspaces_List_ActionHandler('', '', ''));
        const fetchFolderData = async () => {
            const { data } = await workspace_folder_data(id);
            const { name } = data.data;
            setFolderName(name, id);
        };
        if (id) {
            fetchFolderData();
        }
        // fetchDropdownData();
        const data = localStorage.getItem(`account0`);
        setMockData(JSON.parse(data));
        return () => {
            localStorage.removeItem(`account0`);
        };
    }, []);
    const fetchDropdownData = async () => {
        try {
            const { data } = await getAllUserList();
            setUser(data);
        } catch (err) {}
    };
    const getData = () => {
        const data = localStorage.getItem(`account0`);
        setMockData(JSON.parse(data));
    };
    const updateFolderData = async (body, folderId) => {
        try {
            await workspace_folder_update_api(body, folderId);
            let navigateObj = {
                name: state?.name,
                id: state?.id,
            };
            const queryParams = new URLSearchParams(navigateObj).toString();
            const queryParamsObject = Object.fromEntries(
                new URLSearchParams(queryParams)
            );
            Navigate(
                `/workspaces/${queryParamsObject.name}/${queryParamsObject.id}/details`
            );
        } catch (err) {}
    };
    const onFinish = (values) => {
        const folderData = {
            workspace_id: state?.id,
            folder_name: values.folder_name,
            notes: answer,
            created_by_name: values.created_by_name,
            logo: image,
            is_restricted: restrict ? 1 : 0,
            client_ids: mockData,
        };
        dispatch(
            workspaces_Supporting_Document_FolderCreate_ActionHandler(
                folderData
            )
        );

        // setTimeout(() => {
        //     setMockData(null)
        //     localStorage.removeItem(`account0`);
        // }, 2000);
    };
    const onChangeCkEditor = (event, editor) => {
        const data = editor.getData();
        setAnswer(data);
        // onChange(data);
    };
    const handleCreatefolder = () => {
        // if (!folderName) {
        //     setErrorMessage("Please fill the required field.");
        //     return;
        // } else {
        //     setErrorMessage("");
        // }

        if (id) {
            const body = {
                name: folderName,
            };
            updateFolderData(body, id);
        } else {
            let navigateObj = {
                name: state?.name,
                id: state?.id,
            };
            const queryParams = new URLSearchParams(navigateObj).toString();

            let data = {
                name: folderName,
            };

            if (state?.fromFolder === 'Action') {
                dispatch(
                    workspaces_Folder_Create_ActionHandler(
                        state?.id,
                        data,
                        Navigate,
                        queryParams
                    )
                );
            }

            if (state?.fromFolder === 'dataSupporting') {
                dispatch(
                    workspaces_Supporting_Document_FolderCreate_Restrict_ActionHandler(
                        state?.id,
                        data,
                        Navigate,
                        queryParams
                    )
                );
            }

            if (state?.fromFolder === 'dataTemplate') {
                dispatch(
                    workspaces_Output_Template_FolderCreate_ActionHandler(
                        state?.id,
                        data,
                        Navigate,
                        queryParams
                    )
                );
            }
        }
    };
    const showDrawer = () => {
        setEditId('');
        setOpen(true);
    };
    const onClose = () => {
        setEditData(null);
        setOpen(false);
        setIsModalOpen(false);
    };
    const EditRecord = (id) => {
        const data = JSON.parse(localStorage.getItem(`account0`));
        const foundItem = data?.find((item, index) => index === id);
        setEditData(foundItem);
        setOpen(true);
        setEditId(0);
    };
    const handleChange = (value) => {};
    const columns = [
        // {
        //   title: "Sr.",
        //   dataIndex: "id",
        //   key: "id",
        //   sorter: (a, b) => a.id.localeCompare(b.id),
        // },
        {
            title: 'Account Name',
            dataIndex: 'client_id',
            key: 'client_id',
            render: (text, record) => (
                <span>
                    <div key={record.client_id}>{record.name}</div>
                </span>
            ),
        },
        {
            title: 'Workspace',
            dataIndex: 'workspace',
            key: 'workspace',
            render: (text, record) => (
                <span>
                    {record.workspace?.map((tag) => {
                        return (
                            <Tag key={tag} className='tag-data'>
                                <Tooltip title={tag.name ?? tag.workspace_name}>
                                    {tag.name != undefined
                                        ? tag.name.length > 40
                                            ? tag.name.substring(0, 40) + '...'
                                            : tag.name
                                        : tag.workspace_name.length > 40
                                        ? tag.workspace_name.substring(0, 40) +
                                          '...'
                                        : tag.workspace_name}
                                </Tooltip>
                            </Tag>
                        );
                    })}
                </span>
            ),
        },
        {
            title: <div style={{ textAlign: 'center' }}>Action</div>,
            key: 'action',
            width: 100,
            render: (text, record, index) => (
                <div
                    style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                    <img
                        src={editIcon}
                        onClick={() => EditRecord(index)}
                        alt='Edit'
                        style={{ cursor: 'pointer' }}
                    />
                    <img
                        src={trash}
                        alt='Delete'
                        style={{ cursor: 'pointer' }}
                        onClick={(e) => handleDelete(index)}
                    />
                </div>
            ),
        },
    ];
    const handlePageChange = (page) => {
        setCurrentPage(page);
        // dispatch(QuickActionFolderListHandler(folderid, searchValue,page));
    };
    const handleDelete = (id) => {
        setDeleteIndex(id);
        setIsModalOpen(true);
    };
    const handleOk = () => {
        const key = `account0`;
        const data = localStorage.getItem(key);
        if (data) {
            const items = JSON.parse(data);
            const filteredItems = items.filter(
                (item, index) => index !== deleteIndex
            );
            localStorage.setItem(key, JSON.stringify(filteredItems));
            setMockData(filteredItems);
        }
        Swal.fire({
            icon: 'success',
            title: 'Account Successfully Deleted.',
            showConfirmButton: false,
            confirmButtonColor: 'rgb(231,52,70)',
            timer: 1500,
        });
        setIsModalOpen(false);
    };
    ///////////////////////////
    const beforeUpload = async (file) => {
        if (!validateFileType(file)) {
            setError('You can only upload JPG/PNG files!');
            return Upload.LIST_IGNORE;
        }
        if (!validateFileSize(file)) {
            setError('Image must be smaller than 800KB!');
            return Upload.LIST_IGNORE;
        }
        const isJpgOrPng =
            file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            setError('You can only upload JPG/PNG file!');
            return false;
        }
        try {
            await validateImageDimensions(file);
            setError('');
            setImage(file);
        } catch (errorMsg) {
            setError(errorMsg);
            return Upload.LIST_IGNORE;
        }
        return false; // Prevent upload
    };

    const handleImageChange = ({ file }) => {
        if (file.status === 'done') {
            message.success(`${file.name} file processed successfully.`);
            setError(null);
        } else if (file.status === 'error') {
            setError(`${file.name} file processing failed.`);
        }
    };
    const validateFileType = (file) => {
        return file.type === 'image/jpeg' || file.type === 'image/png';
    };

    const validateFileSize = (file) => {
        return file.size / 1024 / 1024 < 0.8; // Less than 800KB
    };

    const validateImageDimensions = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                const img = new Image();
                img.onload = () => {
                    const width = img.width;
                    const height = img.height;
                    const aspectRatio = width / height;
                    const validAspectRatio = [1 / 1, 4 / 3, 16 / 9].includes(
                        aspectRatio
                    );

                    // return
                    if (width >= 200 && validAspectRatio) {
                        setError('');
                        resolve();
                    } else {
                        reject(
                            'Image must be at least 200 pixels wide and have a valid aspect ratio (1:1, 4:3, or 16:9).'
                        );
                    }
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(file);
        });
    };

    const rows = 10;

    useEffect(() => {
        let newSelectedClientsForRestricted = [];
        if (
            mockData != undefined &&
            mockData != null &&
            Object.keys(mockData).length > 0
        ) {
            mockData.map((item) => {
                newSelectedClientsForRestricted.push(item.client_id);
            });
        }
        setSelectedClientsForRestricted(newSelectedClientsForRestricted);
    }, [mockData]);

    return (
        <div className='new_workspace_main workspace-container'>
            {(workspaceCreateAction ||
                workspaceCreateSupporting_Document ||
                workspaceCreate_OutputTemplate) && <Loader />}
            <div className='new_workspaces-container'>
                <h3>Create New Folder</h3>
                <div
                    className='new-workspace-back'
                    onClick={() => {
                        let navigateObj = {
                            name: state?.name,
                            id: state?.id,
                        };
                        const queryParams = new URLSearchParams(
                            navigateObj
                        ).toString();
                        const queryParamsObject = Object.fromEntries(
                            new URLSearchParams(queryParams)
                        );
                        Navigate(
                            `/workspaces/${queryParamsObject.name}/${queryParamsObject.id}/details`
                        );
                    }}>
                    <MdKeyboardBackspace />
                    Back
                </div>
                <div className='new_workspaces_inner'>
                    <img src={Workspaces_icon} alt='' />
                    <h4>Folder</h4>
                </div>
                <Form
                    name='folderCreate'
                    form={form}
                    initialValues={{
                        folder_name: '',
                        notes: '',
                        created_by_name: '',
                        logo: '',
                        is_restricted: '',
                        client_ids: '',
                    }}
                    onFinish={state.type === 'PUBLIC' ? onFinish : undefined}>
                    <div className='workspace-input-container'>
                        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                            <Col span={12}>
                                <div className='workspaces-input-field w-100'>
                                    <label>
                                        Folder name{' '}
                                        <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <Form.Item
                                        name='folder_name'
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    'Please select a Folder Name Name!',
                                            },
                                        ]}>
                                        <Input
                                            placeholder='folder name'
                                            onChange={(e) =>
                                                setFolderName(e.target.value)
                                            }
                                        />
                                    </Form.Item>
                                </div>
                            </Col>
                            {state.type === 'PUBLIC' && (
                                <Col span={12}>
                                    <div className='workspaces-input-field w-100'>
                                        <label>
                                            Created By{' '}
                                            <span style={{ color: 'red' }}>
                                                *
                                            </span>
                                        </label>
                                        <Form.Item
                                            name='created_by_name'
                                            rules={[
                                                {
                                                    required: true,
                                                    message:
                                                        'Please Enter a Created By Name!',
                                                },
                                            ]}>
                                            <Input placeholder='Created By Name' />
                                        </Form.Item>
                                    </div>
                                </Col>
                            )}
                        </Row>
                        {state.type === 'PUBLIC' && (
                            <>
                                <div className='workspaces-input-field w-100'>
                                    <label>Company Logo</label>
                                    <Form.Item
                                        name='logo'
                                        // rules={[
                                        //     {
                                        //         required: image ? false : true,
                                        //         message:
                                        //             'Please Upload logo!',
                                        //     },
                                        // ]}
                                    >
                                        <Space
                                            direction='vertical'
                                            style={{ width: '100%' }}
                                            size='large'>
                                            <Upload
                                                action=''
                                                listType='picture'
                                                maxCount={1}
                                                className='upload-img'
                                                beforeUpload={beforeUpload}
                                                onChange={handleImageChange}
                                                showUploadList={true}
                                                onRemove={() => {
                                                    setError('');
                                                    setImage(null);
                                                }}>
                                                <Button>Choose File</Button>
                                            </Upload>
                                        </Space>
                                        <p>
                                            &#x2022; JPG or PNG. Max size of
                                            800K
                                        </p>
                                        <p>
                                            &#x2022; Upload your logo with a
                                            width of at least 200 pixels,
                                            ideally maintaining a square (1:1),
                                            4:3, or 16:9 aspect ratio.
                                        </p>
                                        {error && (
                                            <p style={{ color: 'red' }}>
                                                {error}
                                            </p>
                                        )}
                                    </Form.Item>
                                </div>

                                <div className='workspaces-input-field w-100'>
                                    <h4 className='mb-0'>
                                        Notes{' '}
                                        <span style={{ color: 'red' }}>*</span>
                                    </h4>
                                    <p>For internal team only</p>
                                    <Form.Item
                                        name='notes'
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    'Please Enter a Notes!',
                                            },
                                        ]}>
                                        <CKEditor
                                            editor={ClassicEditor}
                                            placeholder=''
                                            onChange={(event, editor) =>
                                                onChangeCkEditor(event, editor)
                                            }
                                            style={{ height: `${rows * 25}px` }}
                                            value={answer}
                                            ref={editorRef}
                                            config={{ toolbar: CKEdiorConfig }}
                                        />
                                    </Form.Item>
                                </div>

                                <div>
                                    <h2 className='mb-0'>
                                        <img src={lock} alt='Lock icon' />{' '}
                                        Access Control
                                    </h2>
                                    <Form.Item name='is_restricted'>
                                        <h3>
                                            Restricted &nbsp;&nbsp;&nbsp;
                                            <Switch
                                                name='is_restricted'
                                                checked={restrict}
                                                onChange={(checked) =>
                                                    setRestrict(checked)
                                                }
                                            />
                                        </h3>
                                        <p>
                                            This option allows you to control
                                            whether the contents of this folder
                                            are accessible to users
                                        </p>
                                        {restrict && (
                                            <>
                                                <h3>
                                                    <img
                                                        src={eye_icon}
                                                        alt='Eye icon'
                                                        style={{
                                                            float: 'left',
                                                        }}
                                                    />{' '}
                                                    &nbsp;&nbsp;Visibility
                                                </h3>
                                                <p>
                                                    Define access for specific
                                                    accounts and their
                                                    associated workspaces.
                                                </p>
                                            </>
                                        )}
                                    </Form.Item>
                                </div>
                                {restrict && (
                                    <>
                                        <Button
                                            icon={<PlusOutlined />}
                                            onClick={showDrawer}>
                                            Add Account
                                        </Button>
                                        <Table
                                            columns={columns}
                                            dataSource={mockData}
                                            // bordered
                                            size='middle'
                                            // pagination={{
                                            //     pageSize:
                                            //         quickactionfolderlistdata?.per_page,
                                            //     total: quickactionfolderlistdata?.total,
                                            //     showSizeChanger: false,
                                            //     onChange: handlePageChange,
                                            // }}
                                            // onChange={(pagination, filters, sorter) =>
                                            //     setSortedInfo(sorter)
                                            // }
                                            className='mytable mt-2'
                                        />
                                    </>
                                )}
                            </>
                        )}
                        <div className='add-worksapce-member'>
                            <div
                                className='create-workspace-btn'
                                onClick={
                                    state.type !== 'PUBLIC'
                                        ? handleCreatefolder
                                        : undefined
                                }>
                                <Button htmlType='submit' className='main-api'>
                                    {id ? 'Update Folder' : 'Create Folder'}
                                </Button>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
            {editData ? (
                <EditAccount
                    onClose={onClose}
                    open={open}
                    editId={editId}
                    data={editData}
                    state={0}
                    getData={getData}
                />
            ) : (
                <AddAccount
                    handleChange={handleChange}
                    onClose={onClose}
                    open={open}
                    data={data}
                    state={0}
                    getData={getData}
                    selectedClientsForRestricted={selectedClientsForRestricted}
                />
            )}
            <Modal
                title='Account Access Removal'
                className='model-center'
                onOk={handleOk}
                open={isModalOpen}
                onCancel={onClose}
                okText='Remove Access'>
                <p>
                    Are you sure you want to remove access for this account?
                    Removing access will revoke its permissions for this folder.
                </p>
            </Modal>
        </div>
    );
};

export default CreateWorkspaceFolder;
